

import React, { useEffect, useRef, useState } from "react"
import { renderizarComponentReact } from "../../renderizarOuRemoverComponentReact";
import { Dict } from "app/utils/Dict";
import { Breadcrumb2Container } from "../../breadcrumb2/Breadcrumb2Container";
import { PesquisaOrdermProducao } from "./PesquisaOrdemProducao";

type PesquisaOrdermProducaoContainerProps = {
    onVoltar: () => void
    onRemover: () => boolean
    passos: Dict<string, () => void>;
}

export const PesquisaOrdermProducaoContainer = (props: PesquisaOrdermProducaoContainerProps) => {

    const passosInterno = useRef<Dict<string, () => void>>(new Dict())

    const onRenderizarPesquisaOrdermProducao = () => renderizarComponentReact(
        <PesquisaOrdermProducaoContainer {...props}/>, "ordem-de-producao-region", true
    )

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useEffect(() => {
        passosInterno.current.set("Pesquisa de Ordem de Produção", () => onRenderizarPesquisaOrdermProducao())
    }, [])


    return (
        <>

            <Breadcrumb2Container
                passos={passosInterno?.current?.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="PesquisaOrdermProducaoContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <PesquisaOrdermProducao
                onOk={() => { }}
                onPesquisar={() => { }}
            />
        </>
    )
}